import { Pipe, PipeTransform } from '@angular/core';
import { cloneDeep } from 'lodash';

@Pipe({
  name: 'sort'
})
export class SortPipe implements PipeTransform {

  transform(values: any[], property: string, sortDir = 'asc'): any[] {
    // Must break value refrence to prevent reursive infintite loop
    const valuesToSort = cloneDeep(values) || [];

    valuesToSort.sort((a, b) => {
      if (!Boolean(a[property])){
        return sortDir === 'asc' ? 1 : -1;
      }

      if (!Boolean(b[property])){
        return sortDir === 'asc' ? -1 : 1;
      }

      if (a[property] < b[property]) {
        return sortDir === 'asc' ? -1 : 1;
      } else if (a[property] > b[property]) {
        return sortDir === 'asc' ? 1 : -1;
      } else {
        return 0;
      }
    }
    );

    return valuesToSort;
  }

}
